
import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: 'https://static.readdy.ai/image/9d639ef6c9792709f408f68c264ec65c/b6631a344f02be59eb1595d17ed9f635.png',
      title: 'Pure Nutrition from Nature',
      subtitle: 'Powered by Moringa',
      description: 'Discover the ancient superfood that modern science confirms as nature\'s most complete nutrition source.'
    },
    {
      image: 'https://static.readdy.ai/image/9d639ef6c9792709f408f68c264ec65c/49353a3f464b40582b0706ec41e1e5ae.png',
      title: 'Ancient Wisdom',
      subtitle: 'Modern Science',
      description: 'Bridging traditional Ayurvedic knowledge with cutting-edge nutritional research for optimal wellness.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Organic%20moringa%20powder%20in%20elegant%20glass%20containers%20with%20fresh%20leaves%2C%20minimalist%20white%20background%2C%20premium%20product%20photography%20with%20natural%20lighting%2C%20health%20supplement%20aesthetic%2C%20modern%20wellness%20lifestyle%2C%20copy%20space%20on%20left%20for%20text%20overlay&width=1920&height=1080&seq=hero-moringa-3&orientation=landscape',
      title: 'Plant-Based Wellness',
      subtitle: 'Pure & Organic',
      description: 'Experience the power of 100% organic, sustainably sourced moringa products for your daily health routine.'
    },
    {
      image: 'https://static.readdy.ai/image/9d639ef6c9792709f408f68c264ec65c/368ab79771ae56c5d6cb8c8862411156.png',
      title: 'Transform Your Health',
      subtitle: 'Naturally',
      description: 'Join thousands who have enhanced their energy, immunity, and vitality with NatureIQ\'s premium moringa products.'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="relative flex items-center justify-center overflow-hidden" style={{ minHeight: '70vh' }}>
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
            index === currentSlide 
              ? 'opacity-100 scale-100' 
              : 'opacity-0 scale-105'
          }`}
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3)), url('${slide.image}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat'
          }}
        />
      ))}

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <div className="transform transition-all duration-700 ease-out">
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
                <span className="block opacity-0 animate-fade-in-up" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
                  {slides[currentSlide].title}
                </span>
                <span className="block text-emerald-300 mt-2 opacity-0 animate-fade-in-up" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}>
                  {slides[currentSlide].subtitle}
                </span>
              </h1>
              
              <p className="text-lg md:text-xl text-gray-100 mb-8 max-w-lg opacity-0 animate-fade-in-up" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
                {slides[currentSlide].description}
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in-up" style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}>
                <Button variant="primary" size="lg" className="bg-emerald-600 hover:bg-emerald-700 whitespace-nowrap cursor-pointer">
                  Shop Now
                </Button>
                <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-emerald-600 whitespace-nowrap cursor-pointer">
                  Discover Moringa
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-emerald-500 w-8'
                : 'bg-white/50 hover:bg-white/75 w-2'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
